module.exports = __webpack_public_path__ + "img/Rogue-dwarf-f-70.0120c515.gif";